import { Controller } from "@hotwired/stimulus"

// Toggles resource-specific config panels (Task/Site closing report, Mitarbeiter
// report options) live as the matching "Verfügbar für" resource checkbox is
// (un)checked — instead of only appearing after a save + reload. Inside the
// Mitarbeiter options it also hides the subject restriction while "Nur über sich
// selbst" is chosen: there is nobody to restrict. While "In der App ausfüllbar" is off it
// warns that the type stays web-only; while it is on, it names the roles that still cannot
// create it.
export default class extends Controller {
  static targets = [
    "checkbox",
    "section",
    "subjectMode",
    "subjectRestriction",
    "appToggle",
    "appOffWarning",
    "appRolesHint",
  ]

  connect() {
    this.sync()
    this.syncSubjectMode()
    this.syncApp()
  }

  syncApp() {
    if (!this.hasAppToggleTarget) return

    const inApp = this.appToggleTarget.checked
    this.appOffWarningTargets.forEach((hint) => hint.classList.toggle("hidden", inApp))
    this.appRolesHintTargets.forEach((hint) => hint.classList.toggle("hidden", !inApp))
  }

  // A save in "Verfügbarkeit & Zuordnung" streams in a fresh roles hint, rendered for the
  // saved toggle — follow the box as it stands, saved or not.
  appRolesHintTargetConnected() {
    this.syncApp()
  }

  sync() {
    const checked = new Set(this.checkboxTargets.filter((c) => c.checked).map((c) => c.value))
    this.sectionTargets.forEach((section) => {
      // A section may name several resources ("Task Site"): shown while any is checked.
      const resources = section.dataset.resource.split(" ")
      section.classList.toggle("hidden", !resources.some((resource) => checked.has(resource)))
    })
  }

  syncSubjectMode() {
    if (!this.hasSubjectRestrictionTarget) return

    const selfOnly = this.subjectModeTargets.some(
      (radio) => radio.checked && radio.value === "self_only",
    )
    this.subjectRestrictionTarget.classList.toggle("hidden", selfOnly)
  }
}
